<template>
  <div class="sp-tab-group">
    <div ref="tabsContainer" class="sp-tab-group__nav">
      <slot name="nav" />
    </div>
    <div ref="panelsContainer" class="sp-tab-group__panels">
      <slot />
    </div>
  </div>
</template>

<script setup>
import { useEventListener, watchOnce } from "@vueuse/core";
import { computed, ref, watch } from "vue";
import { getSlotContentByTagName } from "../../utils/slots";

const activeTab = ref(null);
const tabsContainer = ref(null);
const panelsContainer = ref(null);

const tabs = computed(() => getSlotContentByTagName(tabsContainer, "SP-TAB"));
const tabPanels = computed(() => getSlotContentByTagName(panelsContainer, "SP-TAB-PANEL"));

watchOnce(tabs, (tabs) => {
  registerTabListeners();
  setActiveTab(tabs.at(0));
});

watch(activeTab, () => {
  updateTabsActiveAttribute();
  updateTabPanelsActiveAttribute();
});

function registerTabListeners() {
  tabs.value.forEach((tab) => {
    useEventListener(tab, "click", () => setActiveTab(tab));
  });
}

function updateTabsActiveAttribute() {
  tabs.value.forEach((tab) => {
    tab.setAttribute("active", tab.panel === activeTab.value);
  });
}

function updateTabPanelsActiveAttribute() {
  tabPanels.value.forEach((panel) => {
    panel.setAttribute("active", panel.name === activeTab.value);
  });
}

function setActiveTab(tab) {
  activeTab.value = tab?.panel;
}
</script>

<style scoped lang="scss">
.sp-tab-group {
  display: flex;
  flex-direction: column;
  gap: var(--sp-comp-tab-group-gap, 1rem);
}

.sp-tab-group__nav {
  display: flex;
  gap: 1rem;
  border-bottom: 1px solid #ddd;
  padding-bottom: 0;
  align-items: center;
  justify-content: center;
}

.sp-tab-group__panels {
  display: flex;
  flex-direction: column;
}
</style>
